// @ts-ignore
export const all = (state) => state.all;
